import { Container } from "./styled";
import { ContestsListWidget } from "../../../widgets/my/contests/ContestsList";

const Contests = () => {
    return (
        <Container className="max-w-[1024px] mx-auto">
            <ContestsListWidget />
        </Container>
    );
};

export default Contests;